/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-3",
    "aws_cloud_logic_custom": [
        {
            "name": "hotel",
            "endpoint": "https://mr6eavq0ch.execute-api.eu-west-3.amazonaws.com/dev",
            "region": "eu-west-3"
        },
        {
            "name": "stripeAPI",
            "endpoint": "https://fqpoimktze.execute-api.eu-west-3.amazonaws.com/dev",
            "region": "eu-west-3"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://2xaoyko5afeqlosufvpmq4t7hm.appsync-api.eu-west-3.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-3",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "eu-west-3:da728a58-d675-4328-8b4e-5489aaa81fd0",
    "aws_cognito_region": "eu-west-3",
    "aws_user_pools_id": "eu-west-3_eGYHqQDfL",
    "aws_user_pools_web_client_id": "6mu40rf38ifvdl1lic4olajmbc",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "smarterplanhotels59acedf126ed4868acdc81df5c7ed090148-dev",
    "aws_user_files_s3_bucket_region": "eu-west-3"
};


export default awsmobile;
